module.exports = __webpack_public_path__ + "img/aboutus_mb_2.225cd9eb.jpg";